/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Progress_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "OCR processing progress" |
*
* @param {Ocr_Progress_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_progress_aria_label = /** @type {((inputs?: Ocr_Progress_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Progress_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("État d'avancement du traitement OCR")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR-Verarbeitungsfortschritt")
	if (locale === "it") return /** @type {LocalizedString} */ ("stato di avanzamento dell'elaborazione OCR")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ход обработки OCR")
	if (locale === "es") return /** @type {LocalizedString} */ ("progreso del procesamiento OCR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OCR处理进度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCR処理の進捗状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओसीआर प्रोसेसिंग प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Progresso do processamento OCR")
	return /** @type {LocalizedString} */ ("OCR processing progress")
});